import { HttpErrorResponse, HTTP_INTERCEPTORS, } from "@angular/common/http";
import { AppService } from './app.service';
import { throwError, BehaviorSubject } from "rxjs";
import { catchError, filter, take, switchMap } from "rxjs/operators";
var TokenInterceptor = /** @class */ (function () {
    function TokenInterceptor(authService) {
        this.authService = authService;
        this.isRefreshing = false;
        this.refreshTokenSubject = new BehaviorSubject(null);
    }
    TokenInterceptor.prototype.intercept = function (request, next) {
        var _this = this;
        if (this.authService.getJwtToken()) {
            request = this.addToken(request, this.authService.getJwtToken());
        }
        return next.handle(request).pipe(catchError(function (error) {
            if (error instanceof HttpErrorResponse && error.status === 401) {
                return _this.handle401Error(request, next);
            }
            else {
                return throwError(error);
            }
        }));
    };
    TokenInterceptor.prototype.addToken = function (request, token) {
        return request.clone({
            setHeaders: {
                Authorization: "Bearer " + token,
            },
        });
    };
    TokenInterceptor.prototype.handle401Error = function (request, next) {
        var _this = this;
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);
            return this.authService.refreshToken().pipe(switchMap(function (token) {
                _this.isRefreshing = false;
                _this.refreshTokenSubject.next(token.access_token);
                return next.handle(_this.addToken(request, token.access_token));
            }));
        }
        else {
            return this.refreshTokenSubject.pipe(filter(function (token) { return token != null; }), take(1), switchMap(function (jwt) {
                return next.handle(_this.addToken(request, jwt));
            }));
        }
    };
    return TokenInterceptor;
}());
export { TokenInterceptor };
export var tokenInterceptor = {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true
};
